var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgKompaniaIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18.098,
    height: 30.018,
    viewBox: "0 0 18.098 30.018",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_4770",
    "data-name": "Group 4770",
    transform: "translate(-379 174.158)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_7613",
    "data-name": "Path 7613",
    d: "M47.125,41.162c-1.347-.018-2.695-.049-4.042-.052a2.514,2.514,0,0,1-2.7-1.708,3.1,3.1,0,0,1,.789-3.234c3.512-3.714,6.988-7.469,10.483-11.2,1.187-1.268,2.8-1.346,3.76-.2a2.959,2.959,0,0,1-.284,4.189q-2.961,3.171-5.93,6.333c-.182.195-.349.406-.563.657,1.553.021,3.012.037,4.472.062,1.076.018,1.621.822,2.408,1.778.727.882.136,2.256-.679,3.079-1.1,1.112-2.216,2.206-3.484,3.465,1.295,1.395,2.422,2.6,3.54,3.817,1.506,1.638,1.176,3.876-.689,4.722a2.285,2.285,0,0,1-2.74-.681q-2.615-2.928-5.212-5.877a2.844,2.844,0,0,1,.031-3.953c.3-.342.636-.65.956-.973l-.12-.218",
    transform: "translate(339.994 -197.387)",
    fill: "#dfdfde"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7614",
    "data-name": "Path 7614",
    d: "M183.731,412.661l7.9-8.047a.671.671,0,0,1,.961,0l2.758,2.809a.7.7,0,0,1,0,.978l-7.9,8.047a.67.67,0,0,1-.961,0l-2.758-2.809a.7.7,0,0,1,0-.979",
    transform: "translate(201.037 -566.299)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7615",
    "data-name": "Path 7615",
    d: "M395.586,815.716a2.608,2.608,0,0,1,3.223-1.843,2.669,2.669,0,0,1,1.81,3.282A2.608,2.608,0,0,1,397.4,819a2.669,2.669,0,0,1-1.81-3.282",
    transform: "translate(-4.488 -963.238)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7616",
    "data-name": "Path 7616",
    d: "M17.9,3.987,3.915,18.234a.659.659,0,0,1-.944,0L.2,15.409a.689.689,0,0,1,0-.962L14.184.2a.659.659,0,0,1,.944,0L17.9,3.025a.689.689,0,0,1,0,.962",
    transform: "translate(378.999 -174.157)",
    fill: "#fff"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgKompaniaIcon);
export default __webpack_public_path__ + "static/media/kompania_icon.ea3500b56ee7861fd520b1758fe08a62.svg";
export { ForwardRef as ReactComponent };